import type { RecurrenceEnd, RecurrenceRule } from '../db/models'
import { dateInMonth, dateKey, startOfDay } from '../date/calendar'

/**
 * **Die Regel des Nachfolgers — oder `null`, wenn die Wiederholung hier endet** (T13 #178).
 * `nextDate` ist sein Termin (`null` beim Kontingent ohne Termin: dann zählt der Tag des
 * Abhakens). „Nach n Mal“ zählt eins herunter; „am Datum“ lässt nur Runden bis zu diesem
 * Tag zu.
 */
export function successorRule(rule: RecurrenceRule, nextDate: Date | null, completedAt: Date): RecurrenceRule | null {
  const end = rule.end
  if (!end) return rule
  if (end.kind === 'count') {
    return end.remaining <= 1 ? null : { ...rule, end: { kind: 'count', remaining: end.remaining - 1 } }
  }
  return dateKey(nextDate ?? startOfDay(completedAt)) > end.date ? null : rule
}

/** Vorschläge beim Umschalten im Wähler: 3 Mal, oder ein Monat nach dem Start. */
export function defaultEnd(kind: RecurrenceEnd['kind'], seed: Date): RecurrenceEnd {
  return kind === 'count'
    ? { kind: 'count', remaining: 3 }
    : { kind: 'date', date: dateKey(dateInMonth(seed.getFullYear(), seed.getMonth() + 1, seed.getDate())) }
}

const DATE_KEY = /^\d{4}-\d{2}-\d{2}$/

export function isValidEnd(end: RecurrenceEnd | undefined): boolean {
  if (!end) return true
  return end.kind === 'count'
    ? Number.isInteger(end.remaining) && end.remaining >= 1 && end.remaining <= 999
    : DATE_KEY.test(end.date)
}
